module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/icon--connected-00bf9f3054313f4878151bc890580b38.svg";